<script setup lang="ts">
import BrandMark from '@/components/app/BrandMark.vue'

/**
 * Écran de chargement (SP-27) : la pousse du logo qui germe en boucle — tige, puis les
 * deux feuilles — sur le fond de page flouté. Affiché au démarrage, jusqu'à la première
 * navigation résolue, et pendant une navigation lente (`useNavigationLoading`).
 * L'animation est figée sous `prefers-reduced-motion` (tailwind.css).
 */
defineProps<{ label?: string }>()
</script>

<template>
  <div
    class="fixed inset-0 z-100 flex flex-col items-center justify-center gap-5 bg-background/70 backdrop-blur-sm"
    role="status"
    aria-live="polite"
  >
    <span class="page-loader-mark relative">
      <span
        class="absolute inset-0 -m-3 animate-loader-halo rounded-[36%] bg-primary/20"
        aria-hidden="true"
      />
      <BrandMark :wordmark="false" :size="72" />
    </span>
    <p class="font-serif text-lg text-honey-foreground italic">{{ label ?? 'Un instant…' }}</p>
  </div>
</template>
